export const COMPONENT_NAMES = {
  HUBSPOT_CREDITS_WITH_OVERAGES_TILE: {
    MAIN: 'HubSpotCreditsWithOveragesTile',
    TOOLTIP: 'HubSpotCreditsWithOveragesTileTooltip',
    CHART: 'HubSpotCreditsWithOveragesChart',
    CREDIT_USAGE_WELL_ITEM: 'CreditUsageWellItem',
    BUY_HUBSPOT_CREDITS_BUTTON: 'BuyHubSpotCreditsButton'
  },
  CREDIT_PLAN_COMPARATOR: {
    MAIN: 'CreditPlanComparator',
    TALK_TO_SALES: 'CreditPlanComparatorTalkToSales',
    SERVICE_SELECTOR: {
      MAIN: 'CreditPlanComparatorServiceSelector',
      SERVICES: {
        MARKETING: 'CreditPlanComparatorServiceSelectorMarketing',
        SALES: 'CreditPlanComparatorServiceSelectorSales',
        SERVICE: 'CreditPlanComparatorServiceSelectorService',
        CONTENT: 'CreditPlanComparatorServiceSelectorContent',
        DATA: 'CreditPlanComparatorServiceSelectorData'
      }
    }
  },
  CREDIT_ICON_WITH_POPOVER: 'CreditIconWithPopover',
  CREDIT_ICON_WITH_TOOLTIP: 'CreditIconWithTooltip',
  COMPARE_CREDIT_PLANS_BANNER: {
    MAIN: 'CompareCreditPlansBanner',
    CTA: 'CompareCreditPlansBannerCTA'
  },
  NOTIFICATION_BANNER: 'NotificationBanner',
  CREDITS_CALCULATOR: {
    MAIN: 'CreditsCalculator',
    BUY_NOW: 'CreditsCalculatorBuyNow',
    TALK_TO_SALES: 'CreditsCalculatorTalkToSales'
  },
  LEARN_ABOUT_CREDITS_SECTION: 'LearnAboutCreditsSection',
  HUBSPOT_CREDITS_CARD: {
    MAIN: 'HubSpotCreditsCard',
    LEARN_MORE_LINK: 'HubSpotCreditsCardLearnMoreLink',
    MANAGE_USER_PERMISSIONS_LINK: 'HubSpotCreditsCardManageUserPermissionsLink'
  },
  PERCENT_CREDITS_USED_WIDGET: 'PercentCreditsUsedWidget',
  CREDIT_STATUS_BANNER: {
    MAIN: 'CreditStatusBanner',
    CREDITS_REMAINING: 'CreditStatusBannerCreditsRemaining',
    FEATURE_USAGE: 'CreditStatusBannerFeatureUsage'
  },
  CREDIT_BALANCE_TEXT: {
    MAIN: 'CreditBalanceText',
    TOOLTIP: 'CreditBalanceTextTooltip'
  },
  CREDIT_BALANCE_CONTENT: {
    MAIN: 'CreditBalanceContent',
    CTA: 'CreditBalanceContentCTA',
    CANCEL: 'CreditBalanceContentCancel'
  },
  CREDIT_BALANCE_POPOVER: 'CreditBalancePopover',
  CREDIT_BALANCE_INFO_BOX: 'CreditBalanceInfoBox',
  CURRENT_USAGE: {
    CONTAINER: {
      MAIN: 'CurrentUsageContainer',
      TOOLTIP: 'CurrentUsageContainerTooltip',
      REFRESH_BUTTON: 'CurrentUsageContainerRefreshButton'
    },
    CHART: 'CurrentUsageChart'
  },
  CURRENT_USAGE_SUMMARY: {
    CONTAINER: 'CurrentUsageSummaryContainer',
    WELL_ITEM: 'CurrentUsageSummaryWellItem'
  },
  HISTORICAL_USAGE: {
    CONTAINER: {
      MAIN: 'HistoricalUsageContainer',
      TIME_FRAME_PICKER: 'HistoricalUsageContainerTimeFramePicker',
      NON_BILLED_USAGE_TOGGLE: 'HistoricalUsageContainerNonBilledUsageToggle'
    },
    CHART: 'HistoricalUsageChart'
  },
  USAGE_LOG: {
    CONTAINER: 'UsageLogContainer',
    TABLE: 'UsageLogTable',
    DATE_RANGE_PICKER: 'UsageLogDateRangePicker',
    RATE_SHEET_LINK: 'UsageLogRateSheetLink'
  },
  MANAGE_CREDIT_USAGE: {
    CONTAINER: 'ManageCreditUsageContainer',
    TOOLTIP: 'ManageCreditUsageContainerTooltip',
    CARD: {
      MAIN: 'ManageCreditUsageCard',
      AUTOMATION: {
        MAIN: 'ManageCreditUsageAutomation',
        EXTERNAL_LINK: 'ManageCreditUsageCardAutomationLink'
      },
      BREEZE_INTELLIGENCE: {
        MAIN: 'ManageCreditUsageCardBreezeIntelligence',
        EXTERNAL_LINK: 'ManageCreditsageCardBreezeIntelligenceExternalLink'
      },
      BREEZE_AGENTS: {
        MAIN: 'ManageCreditUsageCardBreezeAgents',
        EXTERNAL_LINK: 'ManageCreditUsageCardBreezeAgentsExternalLink'
      },
      BREEZE_AUTOMATION: {
        MAIN: 'ManageCreditUsageCardBreezeAutomation',
        EXTERNAL_LINK: 'ManageCreditUsageCardBreezeAutomationExternalLink'
      },
      BUYER_INTENT: {
        MAIN: 'ManageCreditUsageCardBuyerIntent',
        EXTERNAL_LINK: 'ManageCreditUsageCardBuyerIntentExternalLink'
      },
      DATA_STUDIO: {
        MAIN: 'ManageCreditUsageCardDataStudio',
        EXTERNAL_LINK: 'ManageCreditUsageCardDataStudioExternalLink'
      },
      EVENTS: {
        MAIN: 'ManageCreditUsageCardEvents',
        EXTERNAL_LINK: 'ManageCreditUsageCardEventsExternalLink'
      },
      MESSAGING: {
        MAIN: 'ManageCreditUsageCardMessaging',
        EXTERNAL_LINK: 'ManageCreditUsageCardMessagingExternalLink'
      },
      CPQ: {
        MAIN: 'ManageCreditUsageCardCPQ',
        EXTERNAL_LINK: 'ManageCreditUsageCardCPQExternalLink'
      },
      CALLING: {
        MAIN: 'ManageCreditUsageCardCalling',
        EXTERNAL_LINK: 'ManageCreditUsageCardCallingExternalLink'
      },
      TEST_FEATURE_GROUP: {
        MAIN: 'ManageCreditUsageCardTestFeatureGroup',
        EXTERNAL_LINK: 'ManageCreditUsageCardTestFeatureGroupExternalLink'
      }
    }
  },
  MANAGE_FEATURE_USAGE_TABLE: {
    MAIN: 'ManageFeatureUsageTable',
    FEATURE_TYPE_ROW: 'ManageFeatureUsageTableFeatureTypeRow'
  },
  USAGE_ALLOWANCE_CARD: {
    MAIN: 'UsageAllowanceCard'
  },
  USAGE_ALLOWANCE_FEATURE_CARD: {
    MAIN: 'UsageAllowanceFeatureCard',
    LINK: 'UsageAllowanceFeatureCardLink'
  },
  YOUR_CREDITS_CARD: {
    MAIN: 'YourCreditsCard',
    TOOLTIP: 'YourCreditsCardTooltip',
    ADD_CREDITS_LINK: 'YourCreditsCardAddCreditsLink',
    MANAGE_CREDIT_SETTINGS: 'YourCreditsCardManageCreditSettings',
    MAXIMUM_MONTHLY_CREDITS: {
      ADD_MORE_CREDITS_LINK: 'YourCreditsCardAddMoreCreditsLink',
      EDIT_BUTTON: 'YourCreditsCardEditMaximumMonthlyCreditEditButton',
      MODAL: 'YourCreditsCardEditMaximumMonthlyCreditModal',
      MODAL_CANCEL_BUTTON: 'YourCreditsCardEditMaximumMonthlyCreditModalCancelButton',
      MODAL_CONFIRM_BUTTON: 'YourCreditsCardEditMaximumMonthlyCreditModalConfirmButton'
    },
    OVERAGE_SETTING: {
      EDIT_BUTTON: 'YourCreditsCardEditOverageSettingEditButton',
      MODAL: 'YourCreditsCardEditOverageSettingModal',
      MODAL_AUTO_UPGRADE_OPTION: 'YourCreditsCardEditOverageSettingModalAutoUpgradeOption',
      MODAL_PAY_AS_YOU_GO_OPTION: 'YourCreditsCardEditOverageSettingModalPayAsYouGoOption',
      MODAL_CANCEL_BUTTON: 'YourCreditsCardEditOverageSettingModalCancelButton',
      MODAL_CONFIRM_BUTTON: 'YourCreditsCardEditOverageSettingModalConfirmButton',
      MODAL_CANCEL_SCHEDULED_CHANGE_BUTTON: 'YourCreditsCardEditOverageSettingModalCancelScheduledChangeButton'
    }
  },
  FEATURE_PAUSED_POPOVER: {
    MAIN: 'FeaturePausedPopover',
    CTA: 'FeaturePausedPopoverCTA'
  },
  USES_CREDITS_LABEL: {
    MAIN: 'UsesCreditsLabel',
    POPOVER: 'UsesCreditsPopover',
    TOOLTIP: 'UsesCreditsTooltip'
  },
  CREDIT_FOOTER_ALERT: 'CreditFooterAlert',
  CREDIT_FOOTER: 'CreditFooter',
  CREDITS_CTA: 'CreditsCTA',
  CREDIT_BILLING_WIZARD: {
    DONE_BUTTON: 'CreditBillingWizardDoneButton',
    OVERAGE_SETTING_SELECTION: 'CreditBillingWizardOverageSettingSelection',
    CREDIT_SPEND_LIMIT_SELECTION: 'CreditBillingWizardCreditSpendLimitSelection'
  },
  MONETIZATION_STATUS_ALERT: 'MonetizationStatusAlert',
  MONETIZATION_STATUS_ICON: 'MonetizationStatusIcon',
  BETA: {
    BADGE: 'BetaBadge'
  },
  FEATURE_TYPE_OVERVIEW_PAGE: {
    STATUS_CHANGE_BUTTON: 'FeatureTypeOverviewPageStatusChangeButton',
    BACK_BUTTON: 'FeatureTypeOverviewPageBackButton'
  },
  FEATURE_TYPE_USAGE_CARD: {
    STATUS_CHANGE_BUTTON: 'FeatureTypeUsageCardStatusChangeButton',
    STATUS_CHANGE_CONFIRMATION_MODAL: 'FeatureTypeUsageCardStatusChangeConfirmationModal',
    STATUS_CHANGE_CONFIRMATION_MODAL_CONFIRM_BUTTON: 'FeatureTypeUsageCardStatusChangeConfirmationModalConfirmButton',
    STATUS_CHANGE_CONFIRMATION_MODAL_VIEW_ALL_WORKFLOWS_LINK: 'FeatureTypeUsageCardStatusChangeConfirmationModalViewAllWorkflowsLink',
    VIEW_SOURCE_LINK: 'FeatureTypeUsageCardViewSourceLink'
  },
  FEATURE_TYPE_USAGE_TOGGLE_CONTAINER: {
    TOGGLE: 'FeatureTypeUsageToggleToggle'
  },
  ACTION_MONETIZATION_ALERT: {
    MAIN: 'ActionMonetizationAlert',
    LEARN_MORE_LINK: 'ActionMonetizationAlertLearnMoreLink'
  },
  FEATURE_MONETIZATION_ALERT: {
    MAIN: 'FeatureMonetizationAlert',
    LEARN_MORE_LINK: 'FeatureMonetizationAlertLearnMoreLink'
  },
  FREE_ACCESS_CARD: {
    MAIN: 'FreeAccessCard',
    USAGE_LIMITS_LINK: 'FreeAccessCardUsageLimitsLink'
  },
  FREE_ACCESS_FOOTER_ALERT: {
    MAIN: 'FreeAccessFooterAlert',
    LEARN_MORE_LINK: 'FreeAccessFooterAlertLearnMoreLink'
  },
  FEATURE_TYPE_HISTORICAL_USAGE_CARD: {
    MAIN: 'FeatureTypeHistoricalUsageCard',
    NON_BILLED_USAGE_TOGGLE: 'FeatureTypeHistoricalUsageCardNonBilledUsageToggle',
    REFRESH_BUTTON: 'FeatureTypeHistoricalUsageCardRefreshButton'
  },
  FEATURE_TYPE_FREE_ACCESS_USAGE_CARD: {
    MAIN: 'FeatureTypeFreeAccessUsageCard',
    LEARN_MORE_LINK: 'FeatureTypeFreeAccessUsageCardLearnMoreLink'
  },
  FREE_ACCESS_BANNER: {
    MAIN: 'FreeAccessBanner'
  },
  USAGE_INFO_POPOVER: {
    MAIN: 'UsageInfoPopover',
    TRIGGER: 'UsageInfoPopoverTrigger',
    FEATURE_LINK: 'UsageInfoPopoverFeatureLink',
    RATE_SHEET_LINK: 'UsageInfoPopoverRateSheetLink',
    MANAGE_USAGE_BUTTON: 'UsageInfoPopoverManageUsageButton'
  },
  USAGE_INFO_TEXT: {
    MAIN: 'UsageInfoText'
  }
};
export const WELL_ITEM_TYPES = {
  SUBSCRIPTION_CREDITS_USED: 'SubscriptionCreditsUsed',
  OVERAGE_CREDITS_USED: 'OverageCreditsUsed',
  CURRENT_OVERAGE_COSTS: 'CurrentOverageCosts'
};
export const BILLING_ACTION_TYPES = {
  DISABLED: 'DISABLED',
  OVERAGE: 'OVERAGE',
  TIER_UPGRADE: 'TIER_UPGRADE'
};
export const FREE_ACCESS = {
  ENDING_SOON_THRESHOLD_DAYS: 4
};